/** react-query хуки блока «Склад». retry выключен: 503 «витрина не собрана / собрана частично» ретраями
 *  не лечится — текст виден сразу (внутри блока). Ключ МП без площадки: склад один для Ozon и WB. */
import { useQuery } from "@tanstack/react-query";

import { getMpWhOps, getOptWhOps } from "@/api/whOps";

const STALE = 5 * 60 * 1000;
const ROOT = "wh-ops";

export function useMpWhOps(dateFrom: string, dateTo: string) {
  return useQuery({
    queryKey: [ROOT, "mp", dateFrom, dateTo],
    queryFn: ({ signal }) => getMpWhOps(dateFrom, dateTo, signal),
    staleTime: STALE,
    retry: false,
  });
}

/** `range` null — период опта не определён (нет витрины опта / слишком длинный): не запрашиваем. */
export function useOptWhOps(range: { from: string; to: string } | null) {
  return useQuery({
    queryKey: [ROOT, "opt", range?.from, range?.to],
    queryFn: ({ signal }) => getOptWhOps(range!.from, range!.to, signal),
    staleTime: STALE,
    retry: false,
    enabled: range !== null,
  });
}
